import Component from '@glimmer/component'
import { service } from '@ember/service'
import SideNavItem from 'teacher-ui-client/components/side-nav/item'
import SideNavIconComponent from 'teacher-ui-client/components/side-nav/icon'
import type SideNavService from 'teacher-ui-client/services/side-nav'
import { t } from 'ember-intl'

export class PrintablesLink extends Component {
  @service sideNav!: SideNavService

  get isVisible() {
    return this.sideNav.showPrintables
  }

  <template>
    {{#if this.isVisible}}
      <SideNavItem @linkTo="subscription-type.printables">
        <SideNavIconComponent @phosphorIcon="phosphor-file-text-fill" />
        <span> {{t "sideNav.reading.printables"}}</span>
      </SideNavItem>
    {{/if}}
  </template>
}

export default PrintablesLink
